import { PendingPhotoVerificationItem } from '../../../application/domain/entities/PendingPhotoVerificationItem';
import { PendingPhotoVerificationResult } from '../../../application/domain/entities/PendingPhotoVerificationResult';
import { PendingPhotoVerificationResponseDto, PendingPhotoVerificationResponseItemDto } from '../dto/res/PendingPhotoVerificationResponseDto';

export class PendingPhotoVerificationMapper {
  static toDomain(dto: PendingPhotoVerificationResponseItemDto): PendingPhotoVerificationItem {
    const fn = dto.firstName || '';
    const ln = dto.lastName || '';
    const mn = dto.middleName || '';
    const fullName = [fn, mn, ln].filter(Boolean).join(' ').trim();

    // Map from new API fields while falling back to old ones to maintain compatibility
    const itemCaseId = dto.everifyCaseId || dto.id || '';
    const itemCaseNumber = dto.everifyCaseNumber || dto.caseNumber || dto.eVerifyCase || null;

    return {
      id: itemCaseId,
      everifyCaseId: itemCaseId,
      name: fullName || 'N/A', // kept for existing UI binding
      firstName: fn || null,
      middleName: mn || null,
      lastName: ln || null,
      documentType: dto.documentType || null,
      documentExpiration: dto.documentExpiration ? new Date(dto.documentExpiration) : null,
      eVerifyCase: itemCaseNumber, // mapped from caseNumber to support UI table
      i9FormId: dto.i9FormId || null,
      email: dto.email || null,
      hireDate: dto.hireDate ? new Date(dto.hireDate) : null,
      eVerifyPhotoUrl: dto.eVerifyPhotoUrl,
      documentPhotoUrl: dto.documentPhotoUrl,
      verificationStatus: dto.verificationStatus || 'pending',
      caseType: dto.caseType,
      agency: dto.agency,
      reason: dto.reason,

      // New properties mapped based on requirements
      caseId: itemCaseId,
      caseNumber: itemCaseNumber || undefined,
      employeeName: fullName || undefined,
      ssn: dto.ssn || undefined,
      location: dto.locationName || undefined,
      status: dto.caseStatusDisplay || undefined,
      pendingAction: dto.pendingUserAction || undefined,
    };
  }

  static toDomainList(dto: PendingPhotoVerificationResponseDto): PendingPhotoVerificationResult {
    return {
      items: dto.data.map(this.toDomain),
      totalPages: dto.pagination.totalPages,
      totalItems: dto.pagination.totalItems,
      currentPage: dto.pagination.currentPage,
    };
  }
}
